import React from "react";
import "../css/ReportsTable.css";
import { MenuItem, Select, FormControl } from "@mui/material/";

function ReportsTable({
	xAxisLabels,
	yAxisLabels,
	setSelectedXAxisTitle,
	selectedXAxisTitle,
	setSelectedYAxisTitle,
	selectedYAxisTitle,
	cleanData,
	handleShowReports,
}) {
	const maxNumOfReports = Math.max(
		...Object.values(cleanData).flatMap((obj) =>
			Object.values(obj).map((arr) => arr.length)
		)
	);
	return (
		<>
			{" "}
			<div id="screen" className="pt-4">
				<table className="table table-borderless rrt">
					<thead>
						<tr>
							<td className="evidence-map-top-left-white"></td>
							<th
								className="evidence-map-x-heading"
								colSpan={xAxisLabels.length}
							>
								{selectedXAxisTitle}
							</th>
						</tr>
						<tr>
							<th className="evidence-map-y-heading borders">
								{selectedYAxisTitle}
							</th>

							{xAxisLabels.map((xAxisLabel) => (
								<th
									key={xAxisLabel}
									className="evidence-map-x-heading-categories borders"
								>
									{xAxisLabel}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{yAxisLabels.map((yAxisLabel) => (
							<tr key={"row-" + yAxisLabel}>
								<th className="evidence-map-y-heading-categories borders">
									{yAxisLabel}
								</th>
								{xAxisLabels.map((xAxisLabel) => {
									const totalReports =
										cleanData[xAxisLabel][yAxisLabel]
											.length;

									let colorClass =
										totalReports / maxNumOfReports;
									colorClass = Math.floor(
										colorClass * 10 + 1
									);
									if (colorClass > 10) {
										colorClass = 10;
									}

									if (totalReports) {
										return (
											<td
												key={xAxisLabel}
												className={
													"borders align-middle cell-color-level-" +
													colorClass
												}
												onClick={() =>
													handleShowReports(
														xAxisLabel,
														yAxisLabel
													)
												}
											>
												<span className="em-cell-circle">
													{totalReports}
												</span>
											</td>
										);
									} else {
										return (
											<td
												className="borders align-middle"
												key={
													"cell-" +
													yAxisLabel +
													"-" +
													xAxisLabel
												}
												onClick={() =>
													handleShowReports(
														xAxisLabel,
														yAxisLabel
													)
												}
											>
												<span className="em-cell-circle-no-value"></span>
											</td>
										);
									}
								})}
							</tr>
						))}
					</tbody>
				</table>
			</div>
			<div id="mobile">
				<div className="pt-4">
					{yAxisLabels.map((yAxisLabel) => (
						<table
							className="table table-borderless rrt"
							key={"table-" + yAxisLabel}
						>
							<thead>
								<tr key={"header-" + yAxisLabel}>
									<th
										className="evidence-map-y-heading-categories-mobile borders"
										colSpan={2}
									>
										{yAxisLabel}
									</th>
								</tr>
							</thead>
							<tbody>
								{xAxisLabels.map((xAxisLabel) => {
									const totalReports =
										cleanData[xAxisLabel][yAxisLabel]
											.length;

									let colorClass =
										totalReports / maxNumOfReports;
									colorClass = Math.floor(
										colorClass * 10 + 1
									);
									if (colorClass > 10) {
										colorClass = 10;
									}

									if (totalReports) {
										return (
											<tr
												key={
													"row-" +
													yAxisLabel +
													"-" +
													xAxisLabel
												}
											>
												<th className="evidence-map-x-heading-categories-mobile borders">
													{xAxisLabel}
												</th>
												<td
													className={
														"borders align-middle cell-color-level-" +
														colorClass
													}
													onClick={() =>
														handleShowReports(
															xAxisLabel,
															yAxisLabel
														)
													}
												>
													<span className="">
														<span className="em-cell-circle">
															{totalReports}
														</span>
													</span>
												</td>
											</tr>
										);
									} else {
										return (
											<tr
												key={
													"row-" +
													yAxisLabel +
													"-" +
													xAxisLabel
												}
											>
												<th className="evidence-map-x-heading-categories-mobile borders">
													{xAxisLabel}
												</th>
												<td
													className="borders align-middle"
													onClick={() =>
														handleShowReports(
															xAxisLabel,
															yAxisLabel
														)
													}
												>
													<span className="em-cell-circle-no-value" />
												</td>
											</tr>
										);
									}
								})}
							</tbody>
						</table>
					))}
				</div>
			</div>
		</>
	);
}

export default ReportsTable;
